export default __webpack_public_path__ + "static/media/IMG_20220928_171733-enhance.a7ebc3bb.jpg";